// extracted by mini-css-extract-plugin
export default {"outer":"LayoutCenterBox_outer__rxlzk","container":"LayoutCenterBox_container__dAUU4","btn-close":"LayoutCenterBox_btn-close__jzx0r"};